import {
  AUTHENTICATE_APOLLO_REQUEST, AUTHENTICATE_APOLLO_SUCCEEDED, AUTHENTICATE_APOLLO_FAILED,
} from 'constants/actionTypes';

import axios from 'axios';
import { createAction } from 'redux-actions';
import { call, put, takeEvery } from 'redux-saga/effects';


const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/1.0`;
const APOLLO_BASE_URL = `${apiUrl}/integrations/apollo`;

/*
* Authenticate apollo
*/
export const authenticateApollo = createAction(AUTHENTICATE_APOLLO_REQUEST, (request, callback) => {
  return { request, callback };
})

const authenticateApolloSucceeded = createAction(AUTHENTICATE_APOLLO_SUCCEEDED, (response) => {
  return response;
})

const authenticateApolloFailed = createAction(AUTHENTICATE_APOLLO_FAILED, (error) => {
  return error;
})

function* authenticateApolloSaga(action) {
  const { request, callback } = action.payload;

  const authenticateApolloAPI = () => {
    return axios({
      method: 'POST',
      url: APOLLO_BASE_URL,
      data: request
    }).then(response => response.data);
  }

  try {
    const response = yield call(authenticateApolloAPI);
    if (response) {
      yield put(authenticateApolloSucceeded(response));
      if (callback) {
        callback(response);
      }
    }
  } catch (error) {
    yield put(authenticateApolloFailed(error));
  }
}

export default function* apolloSaga() {
  yield takeEvery(AUTHENTICATE_APOLLO_REQUEST, authenticateApolloSaga);
}
